export default __webpack_public_path__ + "static/media/bytes.e167a3ec.svg";